export const XLG_COL_WIDTH = 220;
export const LARGE_COL_WIDTH = 135;
export const STATUS_COL_WIDTH = 148;
export const MEDIUM_COL_WIDTH = 100;
export const SMALL_COL_WIDTH = 75;

export const BAND_COL_WIDTH = LARGE_COL_WIDTH;
